import { JSX } from 'solid-js';
import { TranslationProvider } from '@trimble/solidjs-utils';
import { useApiServices } from './ApiServiceProvider';

export function TranslationProviderWithUserLanguage(
  props: Readonly<{
    children?: JSX.Element;
  }>
): JSX.Element {
  const { tcTcpsApi } = useApiServices();
  const currentUser = tcTcpsApi.getCurrentUser();

  return (
    <TranslationProvider
      userLanguageReady={currentUser.isSuccess || currentUser.isError}
      userLanguage={currentUser.data?.language}
    >
      {props.children}
    </TranslationProvider>
  );
}
